import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
export var lazyBodiedSyncBlockView = function lazyBodiedSyncBlockView(props) {
  return withLazyLoading({
    nodeName: 'bodiedSyncBlock',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-bodied-synced-block-nodeview" */
      './bodiedSyncedBlock').then(function (_ref) {
        var bodiedSyncBlockNodeView = _ref.bodiedSyncBlockNodeView;
        return bodiedSyncBlockNodeView(props);
      });
      return result;
    }
  });
};